<template>
  <div v-if="currentUser && canThisUserView" class="tes-employees-listing">
    <TolAlert v-if="tolAlert" v-bind="tolAlert" />

    <TesEmployeesFilters @change="onActiveInactiveChange" />
    <TesEmployeesAction />
    <tol-table
      :table-data="tesEmployees"
      :columns="columns"
      :is-row-clickable="true"
      @row-click="handleRowClick($event)"
    >
      <template v-slot:tableHeader>
        <th-sortable
          :direction="currentSortField === 'tesEmployeeName' ? currentSortDirection : 'none'"
          field-name="tesEmployeeName"
          @change="onSortOrderChange"
          >{{ $t('tesEmployees.listing.labels.tesEmployeeName') }}</th-sortable
        >

        <th-sortable
          :direction="currentSortField === 'branch_name' ? currentSortDirection : 'none'"
          field-name="branch_name"
          @change="onSortOrderChange"
          >{{ $t('tesEmployees.listing.labels.branch_name') }}</th-sortable
        >

        <th-sortable
          :direction="currentSortField === 'email' ? currentSortDirection : 'none'"
          field-name="email"
          @change="onSortOrderChange"
          >{{ $t('tesEmployees.listing.labels.email') }}</th-sortable
        >

        <th>{{ $t('tesEmployees.listing.labels.roles') }}</th>

        <th>{{ $t('tesEmployees.listing.labels.commissions') }}</th>
      </template>
    </tol-table>

    <Pagination
      :records-per-page="TesEmployeesPerPage"
      :offset="currentPage"
      :record-count="recordCount"
      @change="onChangePaginationParams($event)"
    />
  </div>
</template>

<script>
import {
  TesEmployeesListingGetters,
  TesEmployeesListingActions
} from '@/app/features/tes-employees/features/tes-employees-listing/tes-employees-listing.keys';
import TesEmployeesFilters from '@/app/features/tes-employees/features/tes-employees-listing/components/TesEmployeesFilters';
import TolAlert from '@/app/components/TolAlert';
import { AppActions } from '@/app/app.keys';
import TolTable from '@/app/components/TolTable';
import ThSortable from '@/app/components/ThSortable';
import Pagination from '@/app/components/Pagination';
import TesEmployeesAction from '../tes-employees-listing/components/TesEmployeesActions';

export default {
  name: 'TesEmployeesListing',
  components: {
    TolTable,
    TolAlert,
    ThSortable,
    Pagination,
    TesEmployeesFilters,
    TesEmployeesAction
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    tolAlert() {
      return false;
    },
    tesEmployees() {
      return this.$store.getters[TesEmployeesListingGetters.TesEmployeesList];
    },
    TesEmployeesPerPage() {
      return this.$store.getters[TesEmployeesListingGetters.TesEmployeesPerPage];
    },
    currentPage() {
      return this.$store.getters[TesEmployeesListingGetters.TesEmployeesListingOffset];
    },
    recordCount() {
      return this.$store.getters[TesEmployeesListingGetters.TesEmployeesRecordCount];
    },
    currentSortField() {
      return this.$store.getters[TesEmployeesListingGetters.SortBy];
    },
    currentSortDirection() {
      return this.$store.getters[TesEmployeesListingGetters.SortDirection];
    },
    canThisUserView() {
      return this.currentUser ? this.currentUser.permissions['TES_EMPLOYEE']['VIEW'] : false;
    },
    columns() {
      return ['tesEmployeeName', 'branch_name', 'email', 'roles', 'commissions'];
    },
    activeInactive() {
      return this.$store.getters[TesEmployeesListingGetters.TesEmployeesActiveInactive];
    }
  },
  mounted() {
    this.$store.dispatch(AppActions.SetPageTitle, this.$t('tesEmployees.listing.title'));
    this.$store.dispatch(TesEmployeesListingActions.RetrieveTesEmployees);
  },
  methods: {
    onSortOrderChange(sortOrder) {
      this.$store.dispatch(TesEmployeesListingActions.SetTesEmployeesSortOrder, sortOrder);
    },
    onChangePaginationParams(event) {
      this.$store.dispatch(TesEmployeesListingActions.SetTesEmployeesPaginationParameters, event);
    },
    onActiveInactiveChange(activeInactive) {
      this.$store.dispatch(
        TesEmployeesListingActions.SetTesEmployeesActiveInactive,
        activeInactive
      );
    },
    handleRowClick(evt) {
      this.$router.push(`/tes-employees/${evt.reference_number}`);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.tes-employees-listing {
  padding-left: 0;
}
</style>
